// extracted by mini-css-extract-plugin
export default {"title":"GetFacilities_title__XmpRj","boxForm":"GetFacilities_boxForm__ykLku","form":"GetFacilities_form__25AW+"};